import React, { useState, useEffect } from 'react';
import '../magicscroll/magicscroll.js';
import '../magicscroll/magicscroll.css';
import ArtistPage from './ArtistPage';
import Select from 'react-select';
import MyCarouselBody from './MyCarousel/MyCarouselBody.js';
import ReactSelectStyles from '../scss/ReactSelectStyles.js';

export default function Body() {
  const [name, setName] = useState('');
  const [nameSubmitted, changeStatus] = useState(false);
  const [artistOptions, setArtistOptions] = useState([]);
  const [searching, setSearching] = useState(false);
  const [currentInput, setCurrentInput] = useState('');
  const [customStyles, setCustomStyles] = useState(
    ReactSelectStyles['ReactSelectStyles']
  );

  function handleSubmit(event = '', specificName = '') {
    if (specificName === '') {
      event.preventDefault();
    }
    changeStatus(true);
  }

  function handleChange(event) {
    setName(event.target.value);
  }

  function handleSelectChange(e) {
    console.log('CHANGED');
    setName(e.value);
    handleSubmit('', e.value);
  }

  function setNameFromCarouselPic() {
    alert('From the Carousel');
    handleSubmit('Kanye West');
    setName('Kanye West');
  }

  async function fetchArtists() {
    try {
      let response = await fetch('http://localhost:4000/artists');
      if (response.status === 200) {
        let data = await response.json();
        data = formatData(data);
        setArtistOptions(data);
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  const formatData = (json) => {
    let res = [];
    json.forEach((entry) => {
      res.push({ label: entry['artist'], value: entry['artist'] });
    });
    return res;
  };

  useEffect(() => {});

  const test = (e) => {
    if (e.length > 2) {
      fetchArtists();
    } else setArtistOptions([]);
    // setCurrentInput(e);
    // let res = { label: e, value: e };
    // const updatedArray = [
    //   res,
    //   ...artistOptions.filter((elem, index) => index >= 1),
    // ];
    // console.log(updatedArray);
    // setArtistOptions(updatedArray);
  };

  return nameSubmitted ? (
    <ArtistPage artistName={name} />
  ) : (
    <body className="body">
      <h1>No. 1</h1>
      <p>Search for an artist to view their Hot 100 No. 1 RECORDS</p>
      {/* <form className='searchBar' onSubmit={handleSubmit}>
        <input placeholder='' onChange={handleChange} type='text' />
        <input
          type='image'
          value='submit'
          src={SearchGlass}
          className='searchIcon'
          alt='searchIcon'
        ></input>
      </form> */}
      {/* <div className="selectDropdown searchBar" style={{ zIndex: '99' }}> */}
      <Select
        options={artistOptions}
        onChange={handleSelectChange}
        onSubmit={handleSubmit}
        onInputChange={test}
        styles={customStyles}
        width="100px"
      />
      {/* </div> */}
      <MyCarouselBody handleSelectChange={handleSelectChange} />
      {/* <Carousel setNameFromCarouselPic={setNameFromCarouselPic} /> */}
    </body>
  );
}
